export const TEXT_LENGTH = {
  RADIUS: {
    BASIC_LIMIT: 17,
    MULTICITY_LIMIT: 15,
    BASIC_LENGTH: 14,
    MULTICITY_LENGTH: 12,
    RECENT_LENGTH: 12,
  },
  RECENT_SEARCH: {
    BASIC_LENGTH: 16,
  },
}
